import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "sonner";

import Login from "./pages/Login";
import AppLayout from "./pages/AppLayout";
import Empresas from "./pages/Empresas";
import PnlAnalitico from "./pages/PnlAnalitico";
import Rentabilidad from "./pages/Rentabilidad";
import Overview from "./pages/Overview";
import Projects from "./pages/Projects";
import Accounting from "./pages/Accounting";
import Analytic from "./pages/Analytic";
import Purchases from "./pages/Purchases";
import Sales from "./pages/Sales";
import Timesheets from "./pages/Timesheets";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/app/empresas" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/app" element={<AppLayout />}>
              <Route index element={<Navigate to="empresas" replace />} />
              <Route path="empresas" element={<Empresas />} />
              <Route path="pnl-analitico" element={<PnlAnalitico />} />
              <Route path="rentabilidad" element={<Rentabilidad />} />
              <Route path="overview" element={<Overview />} />
              <Route path="projects" element={<Projects />} />
              <Route path="accounting" element={<Accounting />} />
              <Route path="analytic" element={<Analytic />} />
              <Route path="purchases" element={<Purchases />} />
              <Route path="sales" element={<Sales />} />
              <Route path="timesheets" element={<Timesheets />} />
            </Route>
            <Route path="*" element={<Navigate to="/app/empresas" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}
